import { Flex, Image, Text, useColorMode } from '@chakra-ui/react';
import React, { Fragment } from 'react';

const PowerBy = () => {
  const { colorMode } = useColorMode();
  return (
    <Fragment>
      <Flex alignItems="center" justifyContent="center" mt="30px">
        <Text color="#828282" fontSize="13px" textAlign="center" mr="10px" letterSpacing="3px" fontWeight={600}>
          POWERED BY
        </Text>
        <a href="https://heylayer.com" target="_blank" rel="noreferrer">
          {colorMode === 'light' ? (
            <Image h="26px" src="/images/logo.png" alt="" />
          ) : (
            <Image h="26px" src="/images/Logo-DarkMode.svg" alt="" />
          )}
        </a>
      </Flex>
      <Text textAlign="center" mt="20px" color="#6e757d" fontSize="14px">
        &copy; 2022
      </Text>
    </Fragment>
  );
};

export default PowerBy;
